<nav *ngIf="items.length > 0" class="text-sm font-medium text-gray-500 dark:text-gray-400 flex flex-wrap items-center">
  <ng-container *ngFor="let item of items; let last = last">
    <!-- Always clickable if it has a URL -->
    <a
      *ngIf="item.url"
      [routerLink]="item.url"
      class="hover:text-primary cursor-pointer"
    >
      {{ item.label }}
    </a>

    <!-- Non-clickable text -->
    <span *ngIf="!item.url" class="text-gray-700 dark:text-white">
      {{ item.label }}
    </span>

    <span *ngIf="!last" class="mx-2">/</span>
  </ng-container>

  <!-- Add current page like "Detail" -->
  <span *ngIf="currentPage" class="text-gray-700 dark:text-white font-semibold ml-1">
    / {{ currentPage }}
  </span>
</nav>
